import { Controller } from "@hotwired/stimulus"

/**
 * Toggle controller for showing/hiding content based on select value
 * 
 * Connects to data-controller="toggle"
 * 
 * Values:
 *   - matchValue: Value to match for showing content (default: "explicit")
 *     Set via data-toggle-match-value-value="explicit"
 * 
 * Targets:
 *   - content: Element to show/hide
 * 
 * Example:
 *   <div data-controller="toggle" data-toggle-match-value-value="explicit">
 *     <select data-action="toggle#toggle">
 *       <option value="derived">Derived</option>
 *       <option value="explicit">Explicit</option>
 *     </select>
 *     <div data-toggle-target="content" class="hidden">...</div>
 *   </div>
 */
export default class extends Controller {
  static targets = ["content"]
  static values = {
    matchValue: { type: String, default: "explicit" }
  }

  connect() {
    this.toggle()
  }

  toggle(event) {
    const select = event ? event.target : this.element.querySelector('select')
    const value = select?.value
    
    if (value === this.matchValueValue) {
      this.contentTarget.classList.remove("hidden")
    } else {
      this.contentTarget.classList.add("hidden")
    }
  }
}
